import script from "./AddRole.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRole.vue?vue&type=script&setup=true&lang=js"

import "./AddRole.vue?vue&type=style&index=0&id=35cd8dee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35cd8dee"]])

export default __exports__